import { type Dispatch, Fragment, type SetStateAction } from 'react'

import ChevronDownIcon from '@/modules/chatting/icons/chevron-down.svg'
import { classNames } from '@/utils/helpers'

interface Props {
  details: {
    label: string
    value: string | number
    className?: string
    hideable: boolean
  }[]
  isExpanded: boolean
  setIsExpanded: Dispatch<SetStateAction<boolean>>
}

export const ExpandableDetails = ({
  details,
  isExpanded,
  setIsExpanded,
}: Props) => {
  const filteredDetails = details.filter(
    (detail) => !detail.hideable || isExpanded,
  )

  return (
    <div className="space-y-2">
      {filteredDetails.map((detail, index) => (
        <Fragment key={detail.label}>
          <div className="flex items-center justify-between gap-3 text-sm">
            <p className="text-secondary-300">{detail.label}</p>
            <p className={classNames('text-right', detail.className)}>
              {detail.value}
            </p>
          </div>
          {index < filteredDetails.length - 1 && (
            <div className="border-b border-border-secondary" />
          )}
        </Fragment>
      ))}
      <div className="flex items-center justify-between gap-3">
        <div className="flex-1 border-b border-border-secondary" />
        <button
          onClick={() => setIsExpanded((prev) => !prev)}
          className="flex items-center gap-1 text-sm leading-[22px]"
        >
          {isExpanded ? 'Collapse' : 'View More'}
          <ChevronDownIcon
            className={classNames('h-3 w-3', { 'rotate-180': isExpanded })}
          />
        </button>
        <div className="flex-1 border-b border-border-secondary" />
      </div>
    </div>
  )
}
